export const SET_USER = "SET_USER";
export const RESET_USER = "RESET_USER";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";
export const UPDATE_ACCOUNT_INFO = "UPDATE_ACCOUNT_INFO";
export const UPDATE_ISCOMPANY = "UPDATE_ISCOMPANY";
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
